module.exports = __webpack_public_path__ + "static/media/chrome_logo.b71492fe.png";